
import React from 'react';
import AboutBanner from '../../components/AboutBanner/AboutBanner';
import AboutTimeLine from '../../components/AboutTimeLine/AboutTimeLine';
import AboutKeyChallenge from '../../components/AboutKeyChallenge/AboutKeyChallenge';
import Work from '../../components/Work/Work';
import StelmartAdvantage from '../../components/StelmartAdvantage/StelmartAdvantage';
import AboutChoose from '../../components/AboutChoose/AboutChoose';

const AboutUs = () => {
  return (
    <div >
      <AboutBanner />
      <AboutTimeLine />
      <AboutKeyChallenge />
      <Work />
      <StelmartAdvantage />
      <AboutChoose />
    </div>
  );
};

export default AboutUs;
